import ManualStockEntryPage from "./ManualStockEntryPage";
export default ManualStockEntryPage;
